import React, { useEffect, useState } from "react";
import get from "lodash/get";

import StoryCard6 from "../../molecules/story-card6";
import CollectionName from "../../molecules/collection-name";
import CollectionTitleHeader from "../../molecules/collection-title-header";

import Separator from "../../atoms/separator";
import { AdContainer } from "../../ads";
import { filterCollection, filterStory } from "../../helper/api";

import "./three-col-six-collection.m.css";

const ThreeColSixCollection = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const collections = filterCollection(collection);
  // const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);

  if (!collections.length) {
    return null;
  }

  // const AdCard = ({ id, mobile }) => {
  //   const [isMobile, setMobile] = useState(false);

  //   useEffect(() => {
  //     if (window && window.innerWidth < 767) {
  //       setMobile(true);
  //     } else {
  //       setMobile(false);
  //     }
  //   }, []);
  //   if (index !== 1) return null;
  //   return (
  //     <>
  //       {isMobile ? (
  //         <div styleName="ad-wrapper" className="hide-desktop">
  //           <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
  //         </div>
  //       ) : null}
  //     </>
  //   );
  // };

  // const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  // const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  // const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  // const thirdCollection = (collection) => {
  //   const stories = filterStory(collection);
  //   return (
  //     <div styleName="collection-wrapper">
  //       <CollectionTitleHeader collection={collection} index={index} />
  //       <div styleName="story-wrapper">
  //         <StoryCard6 story={stories[0]} headerType={4} />
  //         <StoryCard6 story={stories[1]} headerType={4} />
  //         <div styleName="ad-wrapper">
  //           <AdContainer AdClassName="standard-970x90" id="div-gpt-ad-1680156228599-0" desktop={desktopAdUnitId} />
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const renderCollection = (collection, collectionIndex) => {
    const stories = filterStory(collection);
    return (
      <div styleName="collection-wrapper" key={collectionIndex}>
        <CollectionName collection={collection} />
        <div styleName="story-wrapper">
          {stories?.splice(0, 2).map((item, index) => (
            <React.Fragment key={item.id}>
              <StoryCard6 story={item} headerType={4} key={item.id} />
              {/* {collectionIndex === 0 && index === 2 ? (
                <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} />
              ) : null}
              {collectionIndex === 1 && index === 2 ? (
                <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} />
              ) : null}
              {collectionIndex === 2 && index === 2 ? (
                <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} />
              ) : null} */}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };

  // if (location.pathname === "/assembly-elections-2023") {
  //   collections[0].slug = "chhattisgarh-assembly-elections-2023";
  //   collections[1].slug = "mizoram-assembly-elections-2023";
  // }

  return (
    <div styleName="border-wrapper">
      <div styleName="wrapper">{collections.slice(0, 3).map((item, index) => renderCollection(item, index))}</div>
      <div styleName="wrapper second-row">
        {collections.slice(3, 6).map((item, index) => renderCollection(item, index))}
      </div>
      <Separator />
    </div>
  );
};

export default ThreeColSixCollection;
